import React from 'react'
import PropTypes from 'prop-types'
import { entries } from 'lodash'

//this hook is reponsible to return the current width and height of the acutal view port using js built-in
//resize observer functionality. It is thus responsive to the toggle of the nav bar.

const useViewPortObserver = ref => {
	const [size, setSize] = React.useState({})

	React.useEffect(() => {
		if (ref.current == null) return
		const observer = new ResizeObserver(entries => {
			const width = entries[0].borderBoxSize[0].inlineSize
			const height = entries[0].borderBoxSize[0].blockSize
			setSize({ componentWidth: width, componentHeight: height })
		})

		observer.observe(ref.current)
		return () => observer.disconnect()
	}, [])

	return size
}

useViewPortObserver.propTypes = {
	ref: PropTypes.object.isRequired
}

export default useViewPortObserver
